import ChunkLoadFallback from '@/components/ChunkLoadFallback/index.jsx'
import { CHUNK_LOAD_FAILED_SOURCE } from '@/utils/constants'
import { logError } from '@/utils/honeybadger'

const CHUNK_ERROR_PATTERNS = [
  /ChunkLoadError/i,
  /loading css chunk \d+ failed/i
]

const isChunkLoadError = error =>
  CHUNK_ERROR_PATTERNS.some(pattern =>
    pattern.test(error?.name ?? '') || pattern.test(error?.message ?? '')
  )

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const retryDynamicImport = (importFn, { delayMs = 500, retries = 3 } = {}) => {
  const attempt = async retriesLeft => {
    try {
      return await importFn()
    } catch (error) {
      if (!isChunkLoadError(error)) throw error
      if (retriesLeft === 0) {
        logError(error, { context: { source: CHUNK_LOAD_FAILED_SOURCE } })
        return { default: ChunkLoadFallback }
      }
      await sleep(delayMs)
      return attempt(retriesLeft - 1)
    }
  }
  return attempt(retries)
}

export default retryDynamicImport
